
export default {
  name: 'UiTableOfContents',
  /**
   * @type {import('@lovetoknow/ui-components-types').ToCProps
   */
  props: {
    links: {
      type: Array,
      required: false,
      default: () => [],
    },
    listClass: {
      type: String,
      required: false,
      default: '',
    },
    listItemClass: {
      type: String,
      required: false,
      default: '',
    },
    linkClass: {
      type: String,
      required: false,
      default: '',
    },
  },
}
